module.exports = __webpack_public_path__ + "img/recent-events-polls.4676965e.png";